///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-users.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class UsersDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected users: UsersCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.users;
        }

        constructor(model: Dictionary<any>, properties: string[], { criteria }) {
            super(model, properties, criteria);

            this.users = new UsersCollection(this.model[properties[0]], [], {
                criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.title = 'LABEL_USER';
            this.allSelectedLabel = 'LABEL_ALL_CREATED_BY_USERS';
            this.totalSelectedMessage = 'LABEL_TOTAL_CREATED_BY_USERS_SELECTED';
        }
    }
}
